import { render, staticRenderFns } from "./TSLManagement.vue?vue&type=template&id=33695e16&scoped=true&"
import script from "./TSLManagement.vue?vue&type=script&lang=js&"
export * from "./TSLManagement.vue?vue&type=script&lang=js&"
import style0 from "./TSLManagement.vue?vue&type=style&index=0&id=33695e16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33695e16",
  null
  
)

export default component.exports